import { getEntityStringByNgType } from '@editor2/services/conflictResolutionService';
import { type Conflict, type ReorderConflict } from '@editor2/types/conflict';
import { type CourseState } from '@editor2/types/courseState';

export class PageItemMoveConflictResolver {
	acceptCurrent = (state: CourseState, conflict: Conflict | ReorderConflict) => {};

	acceptIncoming = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		const { entityId, attribute, current, incoming } = conflict;

		const incomingParent = incoming as any;
		const incomingParentEntityString = getEntityStringByNgType(incomingParent.type);

		const currentParent = current as any;
		const currentParentEntityString = getEntityStringByNgType(currentParent.type);

		state.initialCourse[incomingParentEntityString].entities[incomingParent.family_id][attribute] =
			incomingParent[attribute];
		state[incomingParentEntityString].entities[incomingParent.family_id][attribute] =
			incomingParent[attribute];

		state.initialCourse[currentParentEntityString].entities[currentParent.family_id][attribute] =
			currentParent[attribute].filter((id) => id !== entityId);
		state[currentParentEntityString].entities[currentParent.family_id][attribute] = currentParent[
			attribute
		].filter((id) => id !== entityId);
	};

	acceptBoth = (state: CourseState, conflict: Conflict | ReorderConflict) => {
		throw new Error('Accept both is not allowed for this type of conflict');
	};
}
